import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { PaperContainer } from './PaperContainer';

// The centered gold-background card shared by every standalone
// (unauthenticated) page — login, register, forgot/reset password, and the
// 404 page — previously duplicated in each of those files.
//
// `100vw` (the original value here) doesn't shrink for horizontal padding
// the way `100%` does, and combined with each page's inputs having a fixed
// `width: 350px` (now `width: 100%; max-width: 350px` instead — see those
// files), the card used to force the whole page wider than a phone's
// viewport. `min-height`/no explicit width + this component's own
// horizontal padding is what actually keeps everything inside the
// viewport now, not just the input fix alone.
const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.background};
  min-height: 100vh;
  padding: 0 20px;
  box-sizing: border-box;
`;

const StyledPage = styled.div`
  padding-top: 40px;
  width: 100%;
  max-width: 450px;
`;

const StyledPaperContainer = styled(PaperContainer)`
  padding: 30px 50px 20px 50px;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 30px 20px 20px 20px;
  }
`;

interface OwnProps {
  children?: ReactNode;
}

const AuthPageLayout = (props: OwnProps) => {
  const { children } = props;

  return (
    <PageWrapper>
      <StyledPage>
        <StyledPaperContainer>
          {children}
        </StyledPaperContainer>
      </StyledPage>
    </PageWrapper>
  );
};

export {
  AuthPageLayout,
};
